import { observer } from "mobx-react-lite";
import { runInAction } from "mobx";
import { useOrderFormState } from "@boundary/_hooks/useOrderFormState";
import { getInfoByService } from "@domain/enums/local/getInfoByService";
import { ServiceOption } from "@boundary/components/serviceOption";
import { useDebouncedPriceCalculation } from "@boundary/_hooks/useDebouncedPriceCalculation";
import styles from "./colorSelect.module.scss";

interface ColorSelectProps {
  vm: ReturnType<typeof useOrderFormState>;
}

export const ColorSelect = observer(function ColorSelect({ vm }: ColorSelectProps) {
  if (!vm.currentFile || !vm.currentService) return null;
  if (!vm.currentFile.id || !vm.currentFile.previewUrl) return null;

  const file = vm.currentFile;
  const options = getInfoByService(vm.currentService.type).colorOptions;
  const calculatePrice = useDebouncedPriceCalculation(vm);

  if (!options.length) return null;

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>Цветность</h2>
      <div className={styles.options}>
        {options.map((option, index) => (
          <ServiceOption
            key={index}
            value={option.id === file.colorType}
            onChange={() => {
              runInAction(() => {
                file.colorType = option.id;
              });
              calculatePrice();
            }}
          >
            {option.title}
          </ServiceOption>
        ))}
      </div>
    </div>
  );
});

